import { useQuery } from "react-query";
import { getSelectedNumberOfButtons } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useSelectedNumberOfButtons = () => {
  const { data, isLoading, refetch } = useQuery(
    "GetNumberOfButtons",
    getSelectedNumberOfButtons,
    {
      refetchOnWindowFocus: false,
    }
  );

  return { data, isLoading, refetch };
};
